import React, { Component } from 'react';

/**
 * La marca de conciliación de una línea o de una transferencia (control de caja).
 *
 * El admin verifica afuera —el extracto del banco, la liquidación del lector, la cuenta de MP— y
 * deja acá el resultado: cuadra o hay diferencia, el monto que encontró y una nota. Una diferencia
 * sin nota no se acepta (el backend devuelve 3513): la semana que viene nadie se acuerda de qué era.
 */
class CashCheckEditor extends Component {

    constructor(props) {
        super(props);
        const check = props.check || {};
        this.state = {
            status: check.status || 'ok',
            amount: check.verified_amount == null ? '' : String(check.verified_amount),
            note: check.note || '',
            error: null,
        };
    }

    guardar = () => {
        if (this.state.status === 'diferencia' && this.state.note.trim() === '') {
            this.setState({ error: 'Contá qué diferencia encontraste.' });
            return;
        }
        this.props.onSave({
            status: this.state.status,
            verified_amount: this.state.amount === '' ? null : this.state.amount,
            note: this.state.note.trim(),
        });
    };

    render() {
        const { saving, onCancel, onClear, check, amountLabel = 'Monto verificado', showAmount = true } = this.props;
        const opcion = (valor, texto, color) => (
            <label
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: 16, cursor: 'pointer',
                    fontWeight: this.state.status === valor ? 600 : 400, color: this.state.status === valor ? color : undefined,
                }}
            >
                <input
                    type="radio"
                    checked={this.state.status === valor}
                    onChange={() => this.setState({ status: valor, error: null })}
                />
                {texto}
            </label>
        );

        return (
            <div style={{ background: '#f8f9fb', border: '1px solid #e1e5eb', borderRadius: 6, padding: '12px 14px' }}>
                <div className="mb-2">
                    {opcion('ok', 'Cuadra', '#2c7a5a')}
                    {opcion('diferencia', 'Hay diferencia', '#a8402f')}
                </div>
                <div className="d-flex flex-wrap" style={{ gap: 12 }}>
                    {showAmount && (
                        <div style={{ width: 180 }}>
                            <label style={{ fontSize: 12, marginBottom: 2 }}>{amountLabel} (opcional)</label>
                            <input
                                type="text"
                                inputMode="decimal"
                                className="form-control form-control-sm"
                                value={this.state.amount}
                                placeholder="$0"
                                onChange={(e) => this.setState({ amount: e.target.value.replace(/[^\d.]/g, '') })}
                            />
                        </div>
                    )}
                    <div style={{ flex: 1, minWidth: 220 }}>
                        <label style={{ fontSize: 12, marginBottom: 2 }}>
                            Nota{this.state.status === 'diferencia' ? ' · obligatoria' : ' (opcional)'}
                        </label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${this.state.error ? 'is-invalid' : ''}`}
                            value={this.state.note}
                            maxLength={500}
                            placeholder={this.state.status === 'diferencia' ? 'Qué encontraste' : 'Ej.: coincide con el extracto'}
                            onChange={(e) => this.setState({ note: e.target.value, error: null })}
                        />
                    </div>
                </div>
                {(this.state.error || this.props.error) && (
                    <div style={{ color: '#a8402f', fontSize: 13, marginTop: 6 }}>{this.state.error || this.props.error}</div>
                )}
                <div className="mt-2">
                    <button className="btn btn-sm btn-primary mr-2" onClick={this.guardar} disabled={saving}>
                        {saving ? 'Guardando…' : 'Guardar'}
                    </button>
                    <button className="btn btn-sm btn-white mr-2" onClick={onCancel} disabled={saving}>Cancelar</button>
                    {check && check.status && (
                        <button className="btn btn-sm btn-link text-muted" onClick={onClear} disabled={saving}>
                            Quitar la marca
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default CashCheckEditor;
